import React, { useEffect, useRef, useState } from 'react';
const TYPEFORM_LIVE_ID = '01M3AHW0K9V2X1XGQPY1HBPYWN';
const TYPEFORM_SCRIPT_SRC = 'https://embed.typeform.com/next/embed.js';
const DEFAULT_LEAD = 'Answer a few quick questions to book your virtual tour.';
type TypeformWindow = Window & {
  tf?: {
    load?: () => void;
  };
};
type FormEmbedProps = {
  lead?: string;
};
export function FormEmbed({
  lead
}: FormEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    // Remove any previous copy so the script re-scans the page for this embed on every mount.
    document.querySelectorAll(`script[src="${TYPEFORM_SCRIPT_SRC}"]`).forEach(node => node.remove());
    const script = document.createElement('script');
    script.src = TYPEFORM_SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      ;
      (window as TypeformWindow).tf?.load?.();
    };
    document.body.appendChild(script);

    // Watch for Typeform injecting its iframe so we can hide the loading state.
    const container = containerRef.current;
    const observer = new MutationObserver(() => {
      if (container?.querySelector('iframe')) {
        setLoaded(true);
        observer.disconnect();
      }
    });
    if (container) observer.observe(container, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
      script.remove();
    };
  }, []);
  return <section className="mx-auto mt-10 max-w-2xl px-6" aria-label="Tour request form" data-id="element-22" data-mp="3hhpd1ya16evz">
      <h2 className="mb-5 text-center font-display text-xl italic text-ink" data-id="element-23" data-mp="3cje3zprk88et">
        {lead ?? DEFAULT_LEAD}
      </h2>
      <div className="relative min-h-[520px] w-full" data-id="element-24" data-mp="3qj5ma2p40aym">
        {!loaded && <div className="absolute inset-0 flex items-center justify-center border border-mist-line bg-mist" data-id="element-25" data-mp="3mjofn5xy57rv">
            <span className="font-sans text-[10px] uppercase tracking-[0.35em] text-ink/60" data-id="element-26" data-mp="1w6fr7hn08vpn">
              Loading form…
            </span>
          </div>}
        <div ref={containerRef} data-tf-live={TYPEFORM_LIVE_ID} className="relative min-h-[520px] w-full" data-id="element-27" data-mp="3r9vovg6e3da0" />
      </div>
    </section>;
}